<div *ngIf="customCSS" [innerHTML]="customCSS"></div>

<my-hotkeys-cheatsheet></my-hotkeys-cheatsheet>

<div class="peertube-container" [ngClass]="{ 'user-logged-in': isUserLoggedIn(), 'user-not-logged-in': !isUserLoggedIn() }">
  <div class="root-header">

    <div class="top-left-block">
      <span class="icon icon-menu" role="button" [title]="getToggleTitle()" (click)="menu.toggleMenu()"></span>

      <a class="peertube-title c-hand" (click)="goToDefaultRoute()">
        <span class="icon icon-logo"></span>
        <span class="instance-name">{{ instanceName }}</span>
      </a>
    </div>

    <div class="root-header-right">
      <my-header class="w-100 d-flex justify-content-end"></my-header>
    </div>
  </div>

  <div class="sub-header-container">
    <my-menu *ngIf="menu.isMenuDisplayed"></my-menu>

    <div id="content" tabindex="-1" class="main-col" [ngClass]="{ expanded: menu.isMenuDisplayed === false }">

      <div class="main-row">

        <div *ngIf="broadcastMessage" class="broadcast-message alert" [ngClass]="broadcastMessage.class">
          <div [innerHTML]="broadcastMessage.message"></div>

          <my-global-icon
            *ngIf="broadcastMessage.dismissable" (click)="hideBroadcastMessage()"
            iconName="cross" role="button" title="Close this message" i18n-title
          ></my-global-icon>
        </div>

        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<ngx-loading-bar [includeSpinner]="false" color="var(--mainColor)"></ngx-loading-bar>

<my-confirm></my-confirm>

<p-toast position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div class="notification-block">
      <div class="message">
        <h3>{{ message.summary }}</h3>
        <p>{{ message.detail }}</p>
      </div>

      <my-global-icon [iconName]="getNotificationIcon(message)"></my-global-icon>
    </div>
  </ng-template>
</p-toast>

<ng-container *ngIf="isUserLoggedIn()">
  <my-account-setup-warning-modal #accountSetupWarningModal></my-account-setup-warning-modal>
  <my-admin-welcome-modal #adminWelcomeModal></my-admin-welcome-modal>
  <my-instance-config-warning-modal #instanceConfigWarningModal></my-instance-config-warning-modal>
</ng-container>

<my-custom-modal #customModal></my-custom-modal>
